(ns dre.pages.events
  (:require
   [applied-science.js-interop :as j]
   [clojure.string :as str]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.components.flash.events :as-alias flash]
   [dre.modals.events :as-alias modals]
   [dre.pages.admin.events]
   [dre.pages.admin.client-download.events]
   [dre.pages.admin.feed.events]
   [dre.pages.admin.help.events]
   [dre.pages.admin.survey.events]
   [dre.pages.admin.usage.events]
   [dre.pages.db :as pages]
   [dre.pages.frontpage.events]
   [dre.pages.search.events]
   [dre.pages.detail.events]
   [dre.pages.my-searches.events]
   [dre.pages.my-searches.signals.events]
   [dre.pages.my-searches.tags.events]
   [dre.pages.my-searches.search-history.events]
   [dre.pages.pubmed-compare.events]
   [dre.pages.shared.events]
   [dre.panels.events :as-alias panels]
   [re-frame.core :as rf]))


(def db-path :pages)


;; -- Events

;; TODO redirect to error page when user has no permissions
(rf/reg-event-fx
  ::set-page
  [rf/trim-v]
  (fn-traced
    [{db :db} [route]]
    (let [user (get-in db [:app :user])
          page-id (:handler route)
          {:keys [init-db init-fx title permission-fx]} (get pages/index page-id)
          not-allowed? (and permission-fx
                            (not (permission-fx user)))]
      (if not-allowed?
        {:db (-> db
                 (assoc-in [db-path :current] :not-found)
                 (update-in [db-path :data :not-found] (constantly nil)))}
        {:db (-> db
                 (assoc-in [db-path :current] page-id)
                 (update-in [db-path :data page-id] (partial merge init-db)))
         :fx [[:dispatch [::save-scroll-pos (:current db)]]
              [:dispatch [::set-title title]]
              [:dispatch [::flash/dismiss-all]]
              [:dispatch [::modals/clear]]
              [:dispatch [::panels/clear]]
              (when init-fx
                [:dispatch [init-fx route]])]}))))


(rf/reg-event-fx
  ::save-scroll-pos
  [(rf/path db-path) (rf/inject-cofx ::scroll-pos) rf/trim-v]
  (fn-traced
    [{:keys [db scroll-pos]} [page-id]]
    (when page-id
      {:db (assoc-in db [:data page-id :scroll-pos] scroll-pos)})))


(rf/reg-event-fx
  ::set-title
  [rf/trim-v]
  (fn-traced
    [{db :db} [title]]
    (let [{:keys [language messages]} (:i18n db)
          translated-title (get-in messages [title language])]
      {::set-title (if (str/blank? translated-title) title translated-title)})))


;; Co-effects

(rf/reg-cofx
  ::scroll-pos
  (fn [cofx _]
    (assoc cofx :scroll-pos (.-scrollY js/window))))


;; -- Effects

(rf/reg-fx
  ::set-title
  (fn [title]
    (when-not (str/blank? title)
      (j/assoc! js/document :title title))))


;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (db-path db)))


(rf/reg-sub
  ::current-page-id
  :<- [::state]
  (fn [db _]
    (:current db)))


(rf/reg-sub
  ::current-page-data
  :<- [::state]
  (fn [db _]
    (get-in db [:data (:current db)])))


(rf/reg-sub
  ::scroll-pos
  :<- [::current-page-data]
  (fn [db _]
    (:scroll-pos db 0)))
